<template>
  <div class="part">
    <div class="img">
      <img :src="goods.fileUrl || defaultImg" />
    </div>
    <div class="goodsInfo">
      <span class="name">{{ goods.name }}</span>
      <span class="specification">{{ goods.specification }}</span>
      <span class="model">{{ goods.model }}</span>
      <span class="tp"
        >原价：<i class="cross">￥{{ goods.tagPrice }}</i></span
      >
      <span class="sp">特惠价：￥{{ goods.sellingPrice }}</span>
      <div class="btn" @click="toDetail">立即购买</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    goods: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      defaultImg:
        'https://plantmate-prod.oss-cn-hangzhou.aliyuncs.com/front/shopping/thirdToForth/rBAAv18qV3WIEc9YAAKCN-_Xo7EAAACmQHss-UAAoJP104.jpg'
    }
  },
  methods: {
    toDetail () {
      this.$router.push({
        name: 'goodDetail',
        query: {
          spuId: this.goods.spuId,
          skuId: this.goods.skuId || undefined
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.part {
  width: 583px;
  height: 294px;
  background: linear-gradient(180deg, #9c84d3 0%, #7954d1 100%);
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.5);
  border-radius: 28px;
  display: flex;
  padding: 8px;
  margin-bottom: 32px;
  .img {
    width: 280px;
    height: 278px;
    background: #fff;
    border-radius: 28px 0 0 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
    flex: 1;
    img {
      width: 100%;
    }
  }
  .goodsInfo {
    width: 384px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    height: 278px;
    background: linear-gradient(180deg, #fef8ea 0%, #fee8c4 100%);
    border-radius: 0 28px 28px 0;
    padding: 22px;
    span {
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 100%;
    }
    .name {
      font-size: 21px;
      font-weight: 500;
      color: #2c0d76;
      line-height: 29px;
      margin-bottom: 6px;
    }
    .specification {
      height: 24px;
      font-size: 17px;
      font-weight: 400;
      color: #2c0d76;
      line-height: 24px;
      margin-bottom: 6px;
    }
    .model {
      height: 24px;
      font-size: 17px;
      font-weight: 400;
      color: #666666;
      line-height: 24px;
      margin-bottom: 8px;
    }
    .tp {
      height: 28px;
      font-size: 20px;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
      margin-bottom: 10px;
    }
    .sp {
      height: 33px;
      font-size: 24px;
      font-weight: 500;
      color: #d52222;
      line-height: 33px;
      margin-bottom: 12px;
    }
    .btn {
      width: 142px;
      height: 50px;
      background: linear-gradient(180deg, #9c84d3 0%, #7954d1 100%);
      border-radius: 5px;
      line-height: 50px;
      color: #fff;
      font-size: 21px;
      text-align: center;
      font-weight: 500;
      color: #ffffff;
      cursor: pointer;
    }
    .cross {
      text-decoration: line-through;
    }
  }
}
</style>
